import { render, staticRenderFns } from "./lecturerHomepageWtxh.vue?vue&type=template&id=5da510c6&scoped=true"
import script from "./lecturerHomepageWtxh.vue?vue&type=script&lang=js"
export * from "./lecturerHomepageWtxh.vue?vue&type=script&lang=js"
import style0 from "./lecturerHomepageWtxh.vue?vue&type=style&index=0&id=5da510c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da510c6",
  null
  
)

export default component.exports